<div class="edit-request-dialog">
  <div class="dialog-header">
    <button type="button" mat-icon-button (click)="closeDialog()" aria-label="Close">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2>Edit Request</h2>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-progress-bar *ngIf="loading || submitting" mode="indeterminate"></mat-progress-bar>

    <div *ngIf="loading" class="loading-wrap">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <form [formGroup]="editRequestForm" class="request-form" *ngIf="!loading">
      <!-- Request Details -->
      <div class="form-section">
        <div class="section-header">
          <span class="section-icon primary">
            <mat-icon>assignment</mat-icon>
          </span>
          <span>Request Details</span>
        </div>

        <div class="form-row">
          <div class="form-group form-group--full">
            <label for="issue-description">Issue Description</label>
            <div class="form-field">
              <textarea
                id="issue-description"
                class="w-100"
                formControlName="description"
                placeholder="Enter issue description"
                rows="3">
              </textarea>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="category-select">Category</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="category-select"
                class="w-100"
                formControlName="issue_category_id"
                [options]="categoryList | searchableOptions:'issue_category':'issue_category_id'"
                placeholder="Select category">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group">
            <label for="priority-select">Priority</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="priority-select"
                class="w-100"
                formControlName="priority_id"
                [options]="priorityList | searchableOptions:'priority':'priority_id'"
                placeholder="Select priority">
              </app-searchable-dropdown>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="status-select">Status</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="status-select"
                class="w-100"
                formControlName="status"
                [options]="statusList | searchableOptions:'status':'status_id'"
                placeholder="Select status">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group">
            <label for="estimated-cost">Estimated Cost</label>
            <div class="form-field">
              <input
                id="estimated-cost"
                class="w-100"
                type="number"
                formControlName="estimated_cost"
                placeholder="Enter estimated cost">
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Budget Approved</label>
            <div class="form-field checkbox-field">
              <mat-checkbox formControlName="is_approved">Is Budget Approved?</mat-checkbox>
            </div>
          </div>

          <div class="form-group" *ngIf="requestData?.item?.reported_name">
            <label>Reported By</label>
            <div class="info-field">
              {{ requestData.item.reported_name }} on {{ requestData.item.assigned_at }}
            </div>
          </div>
        </div>
      </div>

      <!-- Assignment Details -->
      <div class="form-section">
        <div class="section-header">
          <span class="section-icon success">
            <mat-icon>person</mat-icon>
          </span>
          <span>Assignment Details</span>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="role-select">Role</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="role-select"
                class="w-100"
                formControlName="role_id"
                [options]="roleList | searchableOptions:'role':'role_id'"
                placeholder="Select role">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group">
            <label for="member-select">Member</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="member-select"
                class="w-100"
                formControlName="assigned_to"
                [options]="allMembers | searchableOptions:'member_name':'user_id'"
                placeholder="Select member">
              </app-searchable-dropdown>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="cancel-button"
      mat-button
      (click)="closeDialog()">
      Cancel
    </button>
    <button
      type="button"
      class="submit-button"
      mat-flat-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="editRequestForm.invalid || loading || submitting">
      <span *ngIf="!submitting">Save</span>
      <span *ngIf="submitting">Saving...</span>
    </button>
  </div>
</div>
